import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
const BookmarkStarIcon = forwardRef((props, ref) => {
  return /* @__PURE__ */ jsx(SvgIcon, { ...props, ref, children: /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "18.732", height: "25.543", viewBox: "0 0 18.732 25.543", children: /* @__PURE__ */ jsx("g", { "data-name": "Group 18702", children: /* @__PURE__ */ jsx("g", { "data-name": "Group 18866", children: /* @__PURE__ */ jsxs("g", { "data-name": "Group 18865", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M97.88 41.543a.873.873 0 0 1-.49-.154l-8.025-5.62-8.025 5.62a.864.864 0 0 1-.883.059.851.851 0 0 1-.457-.756V16.851a.854.854 0 0 1 .851-.851H97.88a.854.854 0 0 1 .851.851v23.841a.851.851 0 0 1-.458.756.86.86 0 0 1-.393.095zm-8.514-7.663a.873.873 0 0 1 .49.154l7.173 5.024V17.7H81.7v21.358l7.173-5.024a.873.873 0 0 1 .493-.154z",
        transform: "translate(-80 -16)",
        fill: "currentColor",
        "data-name": "bookmark (1)"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M8.262 3.5a.44.44 0 0 0-.379-.3l-2.391-.224L4.547.764a.44.44 0 0 0-.81 0l-.945 2.212L.4 3.193a.441.441 0 0 0-.25.77l1.807 1.586L1.424 7.9a.44.44 0 0 0 .655.476l2.063-1.237L6.2 8.372a.441.441 0 0 0 .659-.472l-.533-2.351 1.807-1.585a.441.441 0 0 0 .129-.464zM4.181 7.115",
        transform: "translate(5.225 5.525)",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "1.3px"
      }
    )
  ] }) }) }) }) });
});
export {
  BookmarkStarIcon
};
//# sourceMappingURL=BookmarkStarIcon.js.map
